export const globalEventProperties = {
    language: document.documentElement.lang,
    page_url: window.location.protocol + '//' + window.location.hostname + window.location.pathname,
};
